import { IUserMenuItems } from '@components/UserMenu/UserMenu';
import { Box } from '@mui/material';
import { TFunction } from 'i18next';
import React from 'react';
import { ICountryInfo, toggleLanguage } from '../utils/languageHelper';
import { UserResponse } from '@services/authApi';
import { Locale } from 'types/locale';

export const UserMenuItems = (
  t: TFunction<'translation', undefined>,
  displayedLanguageInfo: ICountryInfo,
  user: UserResponse,
  locale: Locale,
  setLocale: React.Dispatch<React.SetStateAction<Locale>>,
  closeLanguageMenu: () => void
): IUserMenuItems[] => [
  {
    message: (
      <>
        <Box sx={{ mr: 1 }}>{displayedLanguageInfo?.displayName}</Box>
        <img
          src={displayedLanguageInfo?.flag}
          width="20"
          height="20"
          alt={`A ${displayedLanguageInfo?.displayName} country flag icon.`}
        />
      </>
    ),
    id: 'LanguageToggler',
    link: '#',
    onClick: () => toggleLanguage(user, locale, setLocale, closeLanguageMenu),
  },
  {
    message: `${t('my_profile')}`,
    id: 'MyProfile',
    link: 'profile',
    roleRequired: 'profile',
  },
  {
    message: `${t('faq')}`,
    id: 'FAQ',
    link: 'faq',
  },
];
